import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "project_details_content" }

import { ref } from "vue";
import HistoricProjectReviewComponent from "@/modules/project/components/HistoricProjectReviewComponent.vue";
import HistoricProjectEstimateComponent from "@/modules/project/components/HistoricProjectEstimateComponent.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { PROJECT_ROUTE } from "../routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoricProjectDetailsPage',
  setup(__props) {

const selectedTab = ref();
const projectMenu = [
  { name: "project-overview", icon: "mdi-home", label: "Project Details" },
  {
    name: "trades-estimates",
    icon: "mdi-speedometer-slow",
    label: "Trades Estimates",
  },
];
const store = useStore();
const router = useRouter();

const showHistoricProjectsRequestTab = async () => {
  await store.dispatch(
    `${PROJECT_STORE}/setProjectRedirectTabName`,
    "historic-projects-request"
  );
  router.push({ name: PROJECT_ROUTE });
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      class: "tab-list",
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
      "align-tabs": "center",
      stacked: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projectMenu, (tabItem) => {
          return _createVNode(_component_v_tab, {
            key: tabItem.name,
            value: tabItem.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: tabItem.icon
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(tabItem.label), 1)
            ]),
            _: 2
          }, 1032, ["value"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedTab).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projectMenu, (tabValue) => {
          return _createVNode(_component_v_window_item, {
            key: tabValue.name,
            value: tabValue.name
          }, {
            default: _withCtx(() => [
              (tabValue.name === 'project-overview')
                ? (_openBlock(), _createBlock(HistoricProjectReviewComponent, {
                    key: 0,
                    projectRefId: String(_ctx.$route.params?.refId),
                    onViewEstimate: _cache[1] || (_cache[1] = ($event: any) => (selectedTab.value = 'trades-estimates')),
                    onBack: showHistoricProjectsRequestTab
                  }, null, 8, ["projectRefId"]))
                : _createCommentVNode("", true),
              (tabValue.name === 'trades-estimates')
                ? (_openBlock(), _createBlock(HistoricProjectEstimateComponent, {
                    key: 1,
                    estimateId: Number(_ctx.$route.params?.estimateId),
                    onViewDetails: _cache[2] || (_cache[2] = ($event: any) => (selectedTab.value = 'project-overview'))
                  }, null, 8, ["estimateId"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["value"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})